import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../../../../app/hooks";
import {IntegrationForm, IntegrationRequestPartial} from "./createAndUpdate/IntegrationForm";
import {
    clearConnectIntegrationState,
    connectIntegration,
    connectIntegrationRequestSelector,
    connectIntegrationRequestStatusSelector,
    updateConnectIntegrationRequest
} from "../slice/connectIntegrationSlice";
import {RequestStatus} from "../../../../../../api/apiConfiguration";
import {createIntegrationRequestPropertySelector} from "./selector/IntegrationStoreSelector";
import {showSuccessToastNotification} from "../../../../../elements/toastNotification/toastNotificationSlice";

interface ConnectIntegrationFormProps {
    publicBotId: string
    handleClose: () => void
}

export const ConnectIntegrationForm: React.FC<ConnectIntegrationFormProps> = ({
                                                                                  publicBotId,
                                                                                  handleClose
                                                                              }) => {

    const dispatch = useAppDispatch()
    const connectIntegrationRequestStatus = useAppSelector(connectIntegrationRequestStatusSelector)

    useEffect(() => {
        updateRequest({publicBotId})
        return () => {
            dispatch(clearConnectIntegrationState());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (connectIntegrationRequestStatus === RequestStatus.RESOLVED) {
            handleClose()
            dispatch(showSuccessToastNotification({message: "New Integration Connected Successfully"}))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectIntegrationRequestStatus]);

    const updateRequest = (update: IntegrationRequestPartial) => {
        dispatch(updateConnectIntegrationRequest(update))
    }

    const onSubmit = () => {
        dispatch(connectIntegration())
    }

    return <IntegrationForm
        formTitle={"Connect Integration"}
        onClose={handleClose}
        onSubmit={onSubmit}
        updateRequest={updateRequest}
        selectionProvider={createIntegrationRequestPropertySelector(connectIntegrationRequestSelector)}
    />
}
